export function hasValue(value) {
  return value !== null && value !== undefined && value !== ''
}

export function firstPresent(...values) {
  return values.find(hasValue) ?? null
}

export function toFiniteNumber(value) {
  if (!hasValue(value)) return null
  const numeric = Number(value)
  return Number.isFinite(numeric) ? numeric : null
}

export function issueSeverity(issue) {
  return String(firstPresent(issue?.severity, issue?.level, 'INFO')).toUpperCase()
}

export function hasBlockingInvoiceIssue(issues = []) {
  return issues.some(issue => issueSeverity(issue) === 'ERROR')
}

export function ledgerCompanyName(item) {
  return firstPresent(item?.companyNameSnapshot, item?.companyName, item?.customerName) || '-'
}

export function ledgerTargetAmount(item) {
  return firstPresent(item?.targetOutputAmount, item?.targetAmount)
}

export function ledgerUsedAmount(item) {
  return firstPresent(item?.usedOutputAmount, item?.usedAmount)
}

export function ledgerRemainingAmount(item) {
  const explicitRemaining = toFiniteNumber(item?.remainingAmount)
  if (explicitRemaining !== null) return explicitRemaining

  const target = toFiniteNumber(ledgerTargetAmount(item))
  const used = toFiniteNumber(ledgerUsedAmount(item))
  if (target === null || used === null) return null

  return target - used
}

export function ledgerSplitCount(item) {
  return firstPresent(item?.splitCount, item?.chainCount, 0)
}

export function ledgerStatus(item) {
  if (item?.errorMessage) {
    return { label: '异常', className: 'bg-red-50 text-red-700' }
  }
  if (item?.warningMessage) {
    return { label: '提醒', className: 'bg-amber-50 text-amber-700' }
  }
  if (ledgerRemainingAmount(item) === 0) {
    return { label: '已完成', className: 'bg-emerald-50 text-emerald-700' }
  }
  return { label: '未完成', className: 'bg-slate-100 text-slate-600' }
}
